import { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';

/**
 * Checks that user has non-empty saveAccount list.
 * If it's empty, redirects to /savedAccount once.
 */
export const RequireAccountOnceComponent = (props) => {
  const { user, router } = props;

  useEffect(() => {
    if (user) {
      const { savedAccounts = [] } = user;
      if (savedAccounts.length === 0) {
        router.push('/saveAccount');
      }
    }
  }, [user]);

  return null;
};

export const RequireAccountOnce = compose(
  connect(({ auth: { user } }) => ({
    user,
  })),
  withRouter,
)(RequireAccountOnceComponent);
